@use '@lib/assets/styles/main.scss' as *;

.rootEditor {
  position: relative;
}

.disabledEditor {
  border: 1px solid $gray200;
  border-radius: 6px;
  padding: 12px 16px;
}

.noScrollEditor {
  :global(.ql-editor) {
    overflow-y: visible;
  }
}
